export const mediaConstants = {

    FETCH_ALLMEDIA_REQUEST: 'FETCH_ALLMEDIA_REQUEST',
    FETCH_ALLMEDIA_SUCCESS: 'FETCH_ALLMEDIA_SUCCESS',
    FETCH_ALLMEDIA_FAILURE: 'FETCH_ALLMEDIA_FAILURE',

    CREATE_MEDIA_REQUEST: 'CREATE_MEDIA_REQUEST',
    CREATE_MEDIA_SUCCESS: 'CREATE_MEDIA_SUCCESS',
    CREATE_MEDIA_FAILURE: 'CREATE_MEDIA_FAILURE',

    UPDATE_MEDIA_REQUEST: 'UPDATE_MEDIA_REQUEST',
    UPDATE_MEDIA_SUCCESS: 'UPDATE_MEDIA_SUCCESS',
    UPDATE_MEDIA_FAILURE: 'UPDATE_MEDIA_FAILURE',

    DELETE_MEDIA_REQUEST: 'DELETE_MEDIA_REQUEST',
    DELETE_MEDIA_SUCCESS: 'DELETE_MEDIA_SUCCESS',
    DELETE_MEDIA_FAILURE: 'DELETE_MEDIA_FAILURE',

}